import { JSX } from 'react'

import { IconProps } from '../../icon'

const Link: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M18.4427 29.5583C17.7 28.8155 17.1426 27.9487 16.7345 27.0232L18.8281 24.9296C19.0615 25.9444 19.5589 26.9032 20.3283 27.6727C21.3991 28.7435 22.822 29.3329 24.3355 29.3329C25.8491 29.3329 27.2733 28.7435 28.3428 27.6727L35.6771 20.3383C36.7479 19.2675 37.3373 17.8447 37.3373 16.3311C37.3373 14.8176 36.7479 13.3934 35.6771 12.3239C33.4701 10.117 29.8816 10.1143 27.6707 12.3146L26.3211 13.6641C25.4624 13.4521 24.5756 13.3307 23.6675 13.3307C23.3901 13.3307 23.1167 13.3507 22.8433 13.3707L25.7757 10.4383C29.0255 7.18722 34.3129 7.18722 37.5627 10.4383C40.8124 13.6881 40.8124 18.9755 37.5627 22.2253L30.2283 29.5596C28.6548 31.1345 26.5612 32.0012 24.3355 32.0012C22.1099 32.0012 20.0163 31.1331 18.4427 29.5583ZM8 31.6665C8 33.8922 8.86678 35.9858 10.4417 37.5593C12.0152 39.1342 14.1075 40.001 16.3345 40.001C18.5614 40.001 20.6537 39.1342 22.2273 37.5593L25.161 34.6256C24.8876 34.6456 24.6129 34.6656 24.3369 34.6656C23.4288 34.6656 22.542 34.5443 21.6832 34.3322L20.3417 35.6737C19.2709 36.7446 17.848 37.334 16.3345 37.334C14.8209 37.334 13.3981 36.7446 12.3273 35.6737C11.2564 34.6029 10.667 33.1801 10.667 31.6665C10.667 30.153 11.2564 28.7288 12.3273 27.6593L19.6616 20.325C20.7324 19.2542 22.1553 18.6648 23.6688 18.6648C25.1823 18.6648 26.5985 19.2515 27.668 20.3157L27.676 20.325C28.4454 21.0944 28.9428 22.0532 29.1762 23.068L31.2698 20.9744C30.8618 20.049 30.3044 19.1822 29.5616 18.4394C27.988 16.8645 25.8944 15.9977 23.6688 15.9977C21.4432 15.9977 19.3495 16.8645 17.776 18.4394L10.4417 25.7737C8.86678 27.3473 8 29.4409 8 31.6665Z'
      fill='black'
    />
  </svg>
)

export default Link
